import {
  FETCH_ALL_RECIPE_PROCEDURES,
  RESET_RECIPE_PROCEDURES,
  REMOVE_RECIPE_PROCEDURE,
  ADD_RECIPE_PROCEDURE,
  UPDATE_RECIPE_PROCEDURE,
} from '../../mutation-types';

export default {
  [RESET_RECIPE_PROCEDURES](state) {
    state.all = [];
  },

  [FETCH_ALL_RECIPE_PROCEDURES](state, recipeProcedures) {
    state.all = recipeProcedures;
  },

  [REMOVE_RECIPE_PROCEDURE](state, id) {
    state.all = state.all.filter(p => p.id !== id);
  },

  [ADD_RECIPE_PROCEDURE](state, recipeProcedure) {
    state.all.push(recipeProcedure);
  },

  [UPDATE_RECIPE_PROCEDURE](state, { recipeProcedure, id }) {
    state.all.map((p) => {
      if (p.id.toString() === id.toString()) {
        Object.keys(recipeProcedure).map((k) => {
          p[k] = recipeProcedure[k];
          return k;
        });
      }
      return p;
    });
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/recipeProcedure/mutations.js